export default "__VITE_ASSET__BRUnLjER__"